import { useGeneralData } from "@components/GeneralData/GeneralData"

export function useMegMenu() {
    const { megaMenu } = useGeneralData()
    return megaMenu
}
